module.exports = __webpack_public_path__ + "img/typhon_50_63.d8c883bd.png";